<template>
  <div class="pm-dialog-vehicle">

    <div class="flex justify-center outer-area">
      <div class="vs-row w-full">
        <div class="vs-col pm-dialog-equipment-col" v-for="(master,index) in masterList" :key="index" @mousedown="onClick(master.id)">
          <vs-chip
            :color="itemColor(master.id)"
            :transparent="itemTransparent(master.id)"
            :class="[ itemTransparent(master.id) ? 'pm-chip-with-border' : 'pm-chip-without-border' ]"
          >
            {{ master.name }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      isCount : false,
      selectedIds: [],
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      let masterList = [];
      if ( this.isCount === true) {
        const listLength = this.masterMap['vehicles'].length;
        for ( let i=1 ; i <= listLength ; i++ ) {
          masterList.push({ id: i ,name: i + 'T' });
        }
      } else {
        masterList = this.masterMap['vehicles'];
      }
      return masterList;
    },
    enableSave() {
      return true; // ( this.selectedIds && this.selectedIds.find(x => [2,3].includes(x.status) ) );
    },
  },
  methods: {
    initData() {
      this.isCount = this.valueMap && this.valueMap.is_count ? this.valueMap.is_count : false;
      if ( this.isCount === true ) {
        this.selectedIds = this.valueMap && this.valueMap.count ? [{ id: this.valueMap.count, name: this.valueMap.count + 'T', status: 3}] : [];
      } else {
        this.selectedIds = this.valueMap && this.valueMap.value ? JSON.parse(JSON.stringify(this.valueMap.value)) : [];
      }
    },
    itemColor(masterId) {
     let foundId =  this.selectedIds.find(idMap => idMap.id === masterId);
      let itemColorCode = '#828282';
      if ( foundId ) {
         if ( foundId.status === 2 ) {
           itemColorCode = '#09151c';
         } else if (foundId.status === 3 ) {
           itemColorCode = '#20678F';
         }
      }
      return itemColorCode;
    },
    itemTransparent(masterId) {
      let isTransparent = false;
      let foundId =  this.selectedIds.find(idMap => idMap.id === masterId);
      if ( foundId ) {
         if ( foundId.status === 2 ) {
           isTransparent = true;
         }
      }
      return isTransparent;
    },
    onClick(masterId) {
      let foundSelectedId = this.selectedIds.find(idMap => idMap.id === masterId);
      if (foundSelectedId) {
        foundSelectedId.status = ( foundSelectedId.status % 3 ) + 1
        if ( this.isCount === true ) {
          if ( foundSelectedId.status === 2 ) { foundSelectedId.status = 3; } // 予約状態は存在しない。 
          this.selectedIds = [] ;
          this.selectedIds.push( foundSelectedId );
        }
      } else {
        let newSelectedId = JSON.parse(JSON.stringify(this.masterList.find(master => master.id === masterId)));
        newSelectedId.status = 2;
        if ( this.isCount === true ) {
          this.selectedIds = [] ;
        }
        this.selectedIds.push( newSelectedId );
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = ["update"];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      let idMap = {};
      const updateKeyValueMap = {};
      if ( this.isCount === true) {
        let newSelectedId = null;
        this.selectedIds.forEach(selectedId => {
          if ( [2,3].includes(selectedId.status)  ) {
            newSelectedId = Number(selectedId.id);
          }
        });
        updateKeyValueMap[this.columnKey + '#count'] = newSelectedId;
      } else {
        this.selectedIds.forEach(selectedId => {
          idMap[selectedId.id] = selectedId.status;
        });
        updateKeyValueMap[this.columnKey + '#id'] = idMap;
      }
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-vehicle {
  .outer-area {
    padding: 1rem;
    margin: 1rem 6rem;
  }
  .pm-dialog-equipment-col {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
    .pm-chip-with-border {
      border:2px solid #20678F;
      box-sizing: border-box;
      background-color: $pm-paper-white !important;
    }
    .pm-chip-without-border {
      border:2px solid ;
      box-sizing: border-box;
    }
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

